<template>
  <div>
    <v-toolbar dark dense class="mb-2" color="pink darken-4" >
      <v-toolbar-title v-if="!$vuetify.breakpoint.xs" class="subtitle-2">PLAYLISTS</v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-btn  small :x-small="$vuetify.breakpoint.xs" @click="$notification.copy(epgLink)" color="black">
          EPG LINK <v-icon small :x-small="$vuetify.breakpoint.xs" right>mdi-content-copy</v-icon>
        </v-btn>
        <v-btn small :x-small="$vuetify.breakpoint.xs" text  @click="$refs.playlistEditor.open()">
          {{$t('iptv.editor')}} <v-icon small :x-small="$vuetify.breakpoint.xs" right>mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <textarea id="clipboard-area" class="d-none"></textarea>
    <div class="card-items">
      <div class="card-item" v-for="p in list">
        <v-card  height="100%" class="mb-1" elevation="10">
          <v-card-text class="text-center">
            <playlist-item :item="p" />
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-alert class="mt-2 pa-2" dense dark>
        <div class="body-2" v-html="$t('messages.token_generate_warning')" />
      <v-row no-gutters>
        <v-spacer />
        <v-btn @click="generateHash" class="mt-2" :block="$vuetify.breakpoint.xs" outlined>{{$t('auth.generate_hash')}} <v-icon>mdi-progress-upload</v-icon></v-btn>
      </v-row>

    </v-alert>
    <playlist-editor-dialog ref="playlistEditor" :account-id="id"/>
  </div>
</template>

<script>
import iptvService from "@/service/api/iptvService";
import PlaylistItem from "@/components/iptv/editor/PlaylistItem.vue";
import PlaylistEditorDialog from "@/components/iptv/editor/PlaylistEditorDialog.vue";
import AccountService from "@/service/api/accountService";

const EPG_LINK = process.env.VUE_APP_EPG_LINK

export default {
  name: "Playlists",
  components: {PlaylistEditorDialog, PlaylistItem},
  props: {
    id: {
      type: String,
    },
  },
  computed: {
    list() {
      const st = this.st
      if (!st || st === 'all') return this.pl
      return this.pl.filter(p => p.tags.includes(st))
    }
  },
  data() {
    return {
      st: '',
      pl: [],
      tags: [],
      epgLink: EPG_LINK,
      loading: {
        generate: false
      }
    }
  },
  created() {
    this.getTags()
    this.getPlaylists(this.id)
  },
  methods: {
    getTags() {
      iptvService.getTags().then(res => this.tags = res.data)
    },
    getPlaylists() {
      iptvService.getPlaylists(this.id).then(res => this.pl = res.data)
    },
    generateHash() {
      const action = () => {
        this.loading.generate = true
        AccountService.regenerateHash(this.id)
            .then(res => {
              this.$notification.success()
              this.getPlaylists()
            })
            .finally(() => this.loading.generate = false)
      }
      this.$notification.confirm(action)
    }
  },
}
</script>

<style scoped>
.card-items {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em
}

.card-item {
  width: 270px;
  align-self: stretch;
  flex:1;
}
</style>